import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc from 'styled-components';
import {Icon} from '../Icon/Icon';
import {TransparentLogoIconName} from './assets';

export const TransparentLogo: React.FC = () => {
  return (
    <StyledLogoContainer>
      <StyledTransparentLogo
        asset={TransparentLogoIconName.TransparentAboutYouLogo}
      />
    </StyledLogoContainer>
  );
};

const StyledTransparentLogo = linariaStyled(Icon)`
  height: 100%;
  width: 100%;
`;

const StyledLogoContainer = sc.div`
  height: 24px;
  width: 121px;
`;
